const handleFilterChange = (filter, key) => {
  const filters = filter.querySelectorAll(':checked')
  const values = [ ...filters ].map(f => f.value)
  filter.querySelector('.dropdown-toggle').textContent = (() => {
    switch (filters.length) {
    case 0: return 'Select and Filter'
    case 1:
    case 2:
      return [ ...filters ].map(f =>
        f.closest('.form-check').querySelector('.form-check-label').textContent
      ).join(', ')
    default: return `${filters.length} Selected`
    }
  })()
  const resources = document.querySelectorAll('.resource-center-item')
  resources.forEach(resource =>
    resource.style.display =
      (!values.length || values.includes(resource.dataset[key])) ? '' : 'none'
  )
  document.querySelector('.resource-center-no-results').style.display =
    [ ...resources ].filter(r => r.style.display != 'none').length ? 'none' : ''
}

const initFilter = (filter, key) => {
  filter.addEventListener('change', () => handleFilterChange(filter, key))
  filter.addEventListener('click', e => {
    if (e.target.closest('.form-check'))
      e.stopPropagation()
  })
}

document.addEventListener('DOMContentLoaded', () => {
  const filterResourceType = document.getElementById('filterResourceType')
  const filterCategory = document.getElementById('filterCategory')

  initFilter(filterResourceType, 'resourceType')
  initFilter(filterCategory, 'category')

  handleFilterChange(filterCategory, 'category')
})
